import { render, staticRenderFns } from "./StallSpeedFields.vue?vue&type=template&id=88aad540&"
import script from "./StallSpeedFields.vue?vue&type=script&lang=ts&"
export * from "./StallSpeedFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StallSpeedFields.vue"
export default component.exports